<template>
  <div class="ggtf-my-participation">
    <div class="ggtf-empty-state" v-if="videoList.length === 0 && !loading">
      <div class="ggtf-empty-icon">
        <i class="fas fa-film"></i>
      </div>
      <h3>{{ $t('_wdtg._wjl') }}</h3>
      <!-- <p>您还没有参与任何广告投放活动</p> -->
      <!-- <button class="ggtf-browse-btn" @click="activeTab = 'list'">去浏览活动</button> -->
    </div>

    <div v-else>
      <div v-for="video in videoList" :key="video.id">
        <div class="ggtf-my-video-card">
          <div class="ggtf-my-video-cover">
            <img :src="video.img" :alt="video.title" class="ggtf-cover-image" />
          </div>
          <div style="width: 100%; position: relative">
            <div class="ggtf-my-video-info">
              <h4 class="ggtf-my-video-title">{{ video.title }}</h4>
              <div class="ggtf-my-activity-code">{{ $t('_ggtf._hdbm') }}: {{ video.code }}</div>

              <div class="ggtf-my-stats" style="margin-top: 5px">
                <div class="ggtf-my-stat">
                  <span class="ggtf-stat-label">{{ $t('_wdtg._tzje') }}</span>
                  <span class="ggtf-stat-value">${{ video.amount }}</span>
                </div>
                <div class="ggtf-my-stat">
                  <span class="ggtf-stat-label">{{ $t('_wdtg._zsy') }}</span>
                  <span class="ggtf-stat-value ggtf-profit">+${{ video.income }}</span>
                </div>
                <div class="ggtf-my-stat" v-if="video.status == 3">
                  <span class="ggtf-stat-label">{{ $t('_bq._zrsy') }}</span>
                  <span class="ggtf-stat-value ggtf-profit">+${{ video.last_income }}</span>
                </div>
                <div class="ggtf-my-stat">
                  <span class="ggtf-stat-label">{{ $t('_bq._tzzq') }}</span>
                  <span class="ggtf-stat-value ggtf-profit">{{ video.days }}</span>
                </div>
                <div class="ggtf-my-stat">
                  <span class="ggtf-stat-label">{{ $t('_wdtg._cysj') }}</span>
                  <span class="ggtf-stat-value">{{ formatDate(video.create_time) }}</span>
                </div>
              </div>

              <div class="ggtf-status dks2" v-if="video.status === 1">
                <div class="sdgqe">
                  <div class="sdktiqjr">{{ $t('_wdtg._qzf') }}</div>
                </div>

                <div class="sferr">{{ $t('_bq._zfjz') }}</div>
                <div class="ssdgt">{{ $t('_bq.jz') }}:{{ video.last_pay }}</div>
              </div>
              <div class="ggtf-status" v-if="video.status === 3">
                <div class="ggtf-status-3">{{ $t('_wdtg._jxz') }}</div>
              </div>
            </div>

            <div class="bbst1" v-if="video.status === 1">
              <!-- 操作按钮 -->
              <div class="ggtf-action-section" style="align-items: center; justify-content: flex-end">
                <button class="ggtf-buy-btn" :class="{ 'ggtf-disabled': video.status === 3 }" @click="onPay(video)">{{ $t('_bq._qzf') }}</button>
              </div>
            </div>

            <!-- 待结算汇总 -->
            <!-- <div class="gtqe">
              <div class="set1 sdttq1" v-if="video.zr_income_status == 3">
                <div class="sr1qqr">
                  <span>{{ $t('_wdtg._djszje') }}:</span>
                  <div>
                    <span>$</span>
                    <span>{{ video.zr_amount }}</span>
                  </div>
                  <div>{{ $t('_wdtg._gjb', { a: video.zr_count }) }}</div>
                </div>
              </div>
            </div> -->
            <!--  -->
            <div class="aart">
              <!-- 昨日待结算 -->
              <div class="set1 sdttq1 wjsb" v-if="video.zr_income_status == 3">
                <div class="dq13t">
                  <span>[{{ video.zr_date }}]</span>
                  <span>({{ $t('_wdtg._djs') }})</span>
                </div>
                <div class="sbox">
                  <div class="syde">
                    <span class="sywz">{{ $t('_wdtg._zrsy') }}</span>
                    <div class="skke">
                      <span class="sk1 wjsys">$</span>
                      <span class="sydde wjsys">{{ video.zr_income }}</span>
                    </div>
                  </div>
                  <div class="syde">
                    <span class="sywz">{{ $t('_wdtg._dbl') }}</span>
                    <div class="skke">
                      <span class="sk1">$</span>
                      <span class="sykge">{{ video.zr_buy_num }}</span>
                    </div>
                  </div>
                  <div class="syde">
                    <span class="sywz">{{ $t('_wdtg._bfl') }}</span>
                    <div class="skke">
                      <span></span>
                      <span class="sykge">{{ video.zr_play_num }}</span>
                    </div>
                  </div>
                  <div class="syde">
                    <span class="sywz">{{ $t('_wdtg._wdsy') }}</span>
                    <div class="skke">
                      <span class="sk1">$</span>
                      <span class="sykge">{{ video.zr_real_income }}</span>
                    </div>
                  </div>
                  <div class="syde">
                    <span class="sywz">{{ $t('_wdtg._bqffc') }}</span>
                    <div class="skke">
                      <span class="sk1">$</span>
                      <span class="sykge">{{ video.zr_store_income }}</span>
                    </div>
                  </div>
                </div>
                <!-- 按钮 -->
                <div class="sqrcbox">
                  <button class="qzfann" :class="{ than24: video.zr_expired_hours < 24 }" @click="onTransfer(video)">{{ $t('_ggtg._qhz') }}</button>
                </div>
              </div>
              <!-- 收益结算 -->
              <div class="set1 sdttq1" v-if="video.status == 3 && video.jt_income_status > 0 && video.zr_income_status != 3">
                <div class="dq13t">
                  <span>({{ $t('_wdtg._mr0djs') }})</span>
                </div>
                <div class="sbox">
                  <div class="syde">
                    <span class="sywz">{{ $t('_wdtg._jrsy') }}</span>
                    <div class="skke">
                      <span class="sk1">$</span>
                      <span class="sydde">{{ video.jt_income }}</span>
                    </div>
                  </div>
                  <div class="syde">
                    <span class="sywz">{{ $t('_wdtg._dbl') }}</span>
                    <div class="skke">
                      <span class="sk1">$</span>
                      <span class="sykge">{{ video.jt_buy_num }}</span>
                    </div>
                  </div>
                  <div class="syde">
                    <span class="sywz">{{ $t('_wdtg._bfl') }}</span>
                    <div class="skke">
                      <span></span>
                      <span class="sykge">{{ video.jt_play_num }}</span>
                    </div>
                  </div>
                  <div class="syde">
                    <span class="sywz">{{ $t('_wdtg._wdsy') }}</span>
                    <div class="skke">
                      <span class="sk1">$</span>
                      <span class="sykge">{{ video.jt_real_income }}</span>
                    </div>
                  </div>
                  <div class="syde">
                    <span class="sywz">{{ $t('_wdtg._bqffc') }}</span>
                    <div class="skke">
                      <span class="sk1">$</span>
                      <span class="sykge">{{ video.jt_store_income }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- 加载更多 -->
  <div class="ggtf-load-more">
    <button class="ggtf-load-more-btn" @click="loadMore" v-if="hasMore">
      <i class="fas fa-spinner" v-if="loading"></i>
      {{ loading ? $t('_a._jzz') : $t('_a._jzgd') }}
    </button>
    <div class="ggtf-no-more" v-else>{{ $t('_wdtg._mygd') }}</div>
  </div>

  <!-- 视频详情弹窗 -->
  <invest-buy ref="buy" @success="onSuccess"></invest-buy>
  <AdvTransfer ref="transfer" @success="onTransferSuccess"></AdvTransfer>
</template>

<script>
import AdvTransfer from '@/components/adv/AdvTransfer.vue'
import InvestBuy from './InvestBuy.vue'
export default {
  components: { InvestBuy, AdvTransfer },
  data() {
    return {
      loading: false,
      hasMore: true,
      page: 1,
      size: 4,
      videoList: [
        // {
        //   id: 1,
        //   title: 'The Beggar King Returns Full Movie',
        //   activityCode: 'VA50067270',
        //   cover: 'https://via.placeholder.com/300x180/4A5568/FFFFFF?text=Movie+Cover',
        //   myInvestment: 200,
        //   expectedProfit: 25.5,
        //   participateTime: new Date('2025-11-10 14:30:00'),
        //   status: 'active'
        // }
      ]
    }
  },
  created() {
    this.getList()
  },
  methods: {
    // 支付
    onPay(item) {
      this.$refs.buy.open(item, item.code)
    },
    onSuccess() {
      this.getList(1)
    },
    // 划转
    onTransfer(item) {
      this.$refs.transfer.open(item)
    },
    onTransferSuccess() {
      this.getList(1)
    },
    /**
     * 加载列表
     */
    getList(page = 0) {
      let that = this

      //重置
      if (page > 0) {
        this.videoList = []
        this.page = page
        this.isMore = true
      }

      if (this.loading) {
        return
      }
      this.loading = true

      this.$api.videoInvest
        .getMyInvestList({
          page: that.page,
          size: that.size
        })
        .then((res) => {
          that.loading = false
          that.page++
          if (res.data.length == 0) {
            that.hasMore = false
            return
          }

          //增加数据
          res.data.forEach((item) => {
            that.videoList.push(item)
          })

          if (res.data.length < that.size) {
            that.hasMore = false
          } else {
            that.hasMore = true
          }
        })
    },
    formatDate(date) {
      return (
        new Date(date).toLocaleDateString('zh-CN') +
        ' ' +
        new Date(date).toLocaleTimeString('zh-CN', {
          hour: '2-digit',
          minute: '2-digit'
        })
      )
    }
  }
}
</script>

<style>
.set1 {
  margin-top: 10px;
}

.sbox {
  display: flex;
  gap: 20px;
}

.sywz {
  font-size: 14px;
  color: #718096;
}

.syde {
  display: flex;
  flex-direction: column;
  gap: 5px;
  justify-content: space-between;
}

.sydde {
  color: #4caf50;
  font-size: 20px;
  font-weight: bold;
}

.sykge {
  color: #4caf50;
  font-size: 17px;
}

.sk1 {
  font-size: 13px;
  color: #4caf50;
}

.skke {
  display: flex;
  align-items: baseline;
  gap: 2px;
}

.dq13t {
  font-size: 14px;
  color: #888;
}

.sdttq1 {
  display: flex;
  flex-direction: column;
  gap: 15px;

  padding: 10px;
  border: 1px dashed #ccc;
  border-radius: 10px;
}

.sr1qqr {
  display: flex;
  gap: 5px;
  font-size: 15px;
  color: #ff5722;
}
.wjsys {
  color: #ff5722;
}

.wjsb {
  border-color: #ff5722;
}

.aart {
  display: flex;
  gap: 10px;
}

.gtqe {
  display: flex;
}

.bbst1 {
  position: absolute;
  right: 0;
  bottom: 0;
}
.qzfann {
  padding: 10px 20px;
  background-color: #fe6f33;
  color: #fff;
  border-radius: 10px;
  font-size: 12px;
}

.sqrcbox {
  display: flex;
  align-items: center;
  justify-content: center;
}

.than24 {
  background-color: #4caf50 !important;
}

.dks2 {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.sferr {
  color: #f44336;
  font-size: 14px;
}

.ssdgt {
  color: #707070;
  font-size: 14px;
}

.sdgqe {
  display: flex;
}
.sdktiqjr {
  background: #f443362e;
  color: #f44336;
  font-size: 14px;
  border: 1px dashed;
  padding: 5px;
  border-radius: 5px;
}
</style>
